import { Instance, types } from 'mobx-state-tree'
import { AuthStore } from './auth-store'
import { ConfiguratorStore } from './configurator-store'
import { Busket } from './busket'
import DialogsStore from './dialogs-store'
import { UIStore } from './ui-store'
import { Anshlag } from './results_store'

const Store = types.model({
  authStore: types.optional(AuthStore, {}),
  uiStore: types.optional(UIStore, {}),
  dialogsStore: types.optional(DialogsStore, {}),
  configuratorStore: types.optional(ConfiguratorStore, {}),
  BusketStore: types.optional(Busket, {}),
  AnshlagStore: types.optional(Anshlag, {})
})
export default Store

export interface IStore extends Instance<typeof Store> {}
